<template>
  <app-layout>
    <manage-fiscal-obligations-table
      :own-consultant="consultant_id"
      :can-review-fiscal-obligations="can_review_fiscal_obligations"
    ></manage-fiscal-obligations-table>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import ManageFiscalObligationsTable from '../components/ManageFiscalObligationsTable';
export default {
  name: 'FiscalObligations',
  components: { ManageFiscalObligationsTable, AppLayout },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.hasOwnProperty('consultant_profile') && user.consultant_profile !== null) {
      this.consultant_id = user.consultant_profile['id'];
    }
    if (
      user &&
      user.hasOwnProperty('permissions') &&
      !!user.permissions.find(permission => permission.name === 'review_fiscal_obligations')
    ) {
      this.can_review_fiscal_obligations = true;
    }
  },
  data() {
    return {
      consultant_id: null,
      can_review_fiscal_obligations: false,
    };
  },
  computed: {
    consultant() {
      return this.consultant_id;
    },
  },
};
</script>

<style scoped></style>
